// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"c68415e9","208":"e8ca7209","228":"912f5793","432":"69e6adb4","440":"ae950953","492":"a264c2cb","584":"ed9c272f","672":"5488f677","852":"83e54dcf","904":"743ec3f5"}[chunkId] + ".chunk.js";
};